import React from "react"
import { useFormContext } from "react-hook-form"
import Select from 'react-select'

const InputBox = ({usage, type, id, placeholder, value, onChange}) => {
  if (type === undefined) type = 'text'
  return (
    <div className={`${usage}_input`}>
      <input type={type} id={id} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  )
}

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: '100%',
    width: '100%',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#f0f0f0' : '#fff',
    color: '#333',
    '&:hover': {
      backgroundColor: '#e6e6e6',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#aaa',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#333',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '4px',
    marginTop: '0',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '0',
  }),
};

const FormSelectionBox = ({name, options, optionTags, placeholder=""}) => {
  const { register, setValue } = useFormContext()

  const handleChange = (selectedOption) => {
    setValue(name, selectedOption ? selectedOption.value : '')
  }

  const formattedOptions = options.map(option => ({
    value: option,
    label: optionTags ? optionTags[option] : option
  }))

  return (
    <Select
      name={name}
      options={formattedOptions}
      onChange={handleChange}
      isClearable
      placeholder={placeholder}
      styles={customStyles}
    />
  )
}

export { InputBox, FormSelectionBox }